import { ReactElement, useCallback } from 'react';
import { Trans } from 'react-i18next';

import { Link, LinkSize, MarginPosition, usePush, ValidationErrorNotification } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { referralTranslationKeys } from '../../../translations';

type HealthcareFacilitySpecialtyFieldValidationErrorNotificationProps = {
   readonly visitId: number;
};

export const HealthcareFacilitySpecialtyFieldValidationErrorNotification = (
   props: HealthcareFacilitySpecialtyFieldValidationErrorNotificationProps
): ReactElement => {
   const push = usePush();

   const goToReferralToPsychiatricHospital = useCallback(() => {
      push(visitPaths.getReferralToPsychiatricHospitalPath({ params: { visitId: props.visitId } }));
   }, [props.visitId, push]);

   return (
      <ValidationErrorNotification
         testId={'error'}
         margin={MarginPosition.TOP}
         label={
            <Trans
               i18nKey={referralTranslationKeys.referralToHospital.chosenWardRequiresReferralToPsychiatricHospital}
               components={{
                  psychiatricHospitalLink: (
                     <Link
                        testId={'goToReferralToPsychiatricHospital'}
                        block={false}
                        label={referralTranslationKeys.referralToHospital.referralToPsychiatricHospital}
                        size={LinkSize.SMALL}
                        onClick={goToReferralToPsychiatricHospital}
                     />
                  ),
               }}
            />
         }
      />
   );
};
